import React from 'react';
import { useTranslation } from '@shared/core';
import { TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { PrivacyPolicyLink } from './PrivacyPolicyLink';
import { TermsOfServiceLink } from './TermsOfServiceLink';
import { PrivacyNoticeLink } from './PrivacyNoticeLink';

/**
 * Renders the account agreement notice with embedded links.
 *
 * Note: Uses `t` instead of `tq` because the translation requires React component
 * interpolation (<PrivacyPolicy/>, <TermsOfService/>, <PrivacyNotice/>).
 * The `tq` API only supports primitive value interpolation and cannot handle
 * React components as interpolation values.
 *
 * TODO: Migrate to `tq` once @withjoy/tq React component support is released
 * (see joylifeinc/translate PR #42)
 */
export const AccountAgreementNotice = () => {
  const { t } = useTranslation('createWedding');
  const termsAndPrivacy = t('createAccount').termsAndPrivacy({ PrivacyPolicy: PrivacyPolicyLink, TermsOfService: TermsOfServiceLink, PrivacyNotice: PrivacyNoticeLink });
  return (
    <TextV2
      textAlign="center"
      typographyVariant="label1"
      color="gray8"
      style={{ lineHeight: '1.17rem' }}
      fontSize={pxToRem(13)}
    >
      {termsAndPrivacy}
    </TextV2>
  );
};
